import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core'
import {Observable, combineLatest} from 'rxjs'
import {map} from 'rxjs/operators'
import {TerminalEventsListConfigurationService} from '../../services/terminal-events-list-configuration.service'
import {TerminalEvent} from '../../interfaces/terminal-event'

@Component({
  selector: 'app-terminal-event-detail-toggler',
  templateUrl: './terminal-event-detail-toggler.component.html',
  styleUrls: ['./terminal-event-detail-toggler.component.scss'],
  standalone: false,
})
export class TerminalEventDetailTogglerComponent implements OnInit {
  @Input() data$: Observable<TerminalEvent>
  @Input() selectedFilters$: Observable<TerminalEvent>
  @Input() configurationFileName: string =
    'TerminalEventsFieldDefinitionsByType_detail.json'
  @Input() eventName: string = 'sourceName'

  @Output() detailAttributeChanged = new EventEmitter<{
    filter: {key: string; value: string | number | boolean}
    ingestSequence: number
    setSelected: boolean
  }>()
  @Output() jump = new EventEmitter<{type: string; direction: string}>()
  @Output() reset = new EventEmitter<boolean>()

  combinedData$: Observable<any>
  filtered = {scrollIndex: true, dynamicColumns: true}

  constructor(public eventListConfig: TerminalEventsListConfigurationService) {}

  ngOnInit() {
    this.combinedData$ = combineLatest(this.data$, this.selectedFilters$).pipe(
      // map(([data, selected, detailViewConfig]) => {
      map(([data, selected]) => {
        if (!data) {
          return
        }
        return this.eventListConfig.getDetailViewConfig(
          data,
          selected,
          this.configurationFileName,
          this.eventName,
        )
      }),
    )
  }

  selectFilter(event, item) {
    this.detailAttributeChanged.emit({
      filter: {key: item.key, value: item.value},
      ingestSequence: item.ingestSequence,
      setSelected: !item.selected,
    })
  }

  jumpTo(evt) {
    this.jump.emit(evt)
  }

  scrollIntoView(event) {
    event.stopPropagation()
    this.reset.emit(true)
  }
}
